export default "__VITE_ASSET__BB3_Fny4__"